import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-publish-button',
    templateUrl: './publish-button.component.html',
    styleUrls: ['./publish-button.component.scss'],
    standalone: false
})
export class PublishButtonComponent implements OnInit, OnChanges {
  @Input() currentStatusName: string = '';

  @Input() hasWriteAccess: boolean = false;

  @Input() statusOptions: any[] = [];


  @Input() publishTooltip: string = '';

  @Input() optionsTooltip: string = '';

  @Input() menuId: string = 'statusOptionsMenu';

  @Output() publish = new EventEmitter<void>();

  @Output() statusSelected = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    // Force change detection after initialization
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.statusOptions) {
      // Force change detection when statusOptions changes
      setTimeout(() => {
        this.cdr.detectChanges();
      }, 0);
    }
  }

  onPublish() {
    this.publish.emit();
  }

  onStatusChange(status: any) {
    this.statusSelected.emit(status);
  }

  trackByStatusId(index: number, status: any): any {
    return status.id;
  }
}
